"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { PageContainer } from "@/components/page-container";
import { SigmaLogo } from "@/components/sigma-logo";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader } from "@/components/ui/card";
export default function ErrorPage(t0) {
  const $ = _c(12);
  const {
    error,
    reset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex justify-center"><Link aria-label="Sigma Auth home" href="/"><SigmaLogo className="h-8 w-auto text-foreground" /></Link></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CardHeader className="space-y-4 text-center">{t1}<div className="space-y-2"><p className="font-mono text-muted-foreground text-sm">Error</p><h1 className="font-semibold text-2xl leading-none">Something went wrong</h1><CardDescription>An unexpected error occurred. You can try again, or go back to the home page.</CardDescription></div></CardHeader>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== reset) {
    t3 = <Button onClick={reset} type="button">Try again</Button>;
    $[2] = reset;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button asChild={true} variant="outline"><Link href="/" prefetch={false}>Go home</Link></Button>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className="flex min-w-0 flex-col gap-3 sm:flex-row sm:justify-center">{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== error.digest) {
    t6 = error.digest ? <p className="text-center font-mono text-muted-foreground text-xs">Reference: {error.digest}</p> : null;
    $[7] = error.digest;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="flex min-h-svh min-w-0 items-center justify-center"><PageContainer><Card className="mx-auto min-w-0 max-w-md">{t2}<CardContent className="flex min-w-0 flex-col gap-4">{t5}{t6}</CardContent></Card></PageContainer></div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}